import axios from 'axios'
import {
  isLightSignUp,
} from '../../utils/setLocalStorage'

export default {
  namespaced: true,
  state: {
    steps: undefined,
    goToStepNumber: undefined,
    currentStep: undefined,
    attemptingNavigation: false,
    header: false,
    banner: false,
    isLightSignUp: undefined,
  },
  mutations: {
    SET_STEPS(state, steps) {
      state.steps = steps
    },
    SET_CURRENT_STEP(state, currentStep) {
      state.currentStep = currentStep
    },
    SET_HEADER(state, header) {
      state.header = header
    },
    SET_BANNER(state, banner) {
      state.banner = banner
    },
    TRIGGER_STEP_NAVIGATION(state, step) {
      state.attemptingNavigation = true
      const { route } = state.steps[step.step]
      window.location = step.step === 4 ? route.replace(':lead:', step.data.leadId) : route
    },
    SET_IS_LIGHT_SIGN_UP(state, isLight) {
      state.isLightSignUp = isLight
      isLightSignUp(isLight)
    },
  },
  actions: {
    GET_STEPPING({ rootState, commit }) {
      axios(`${rootState.api}/stepping`).then((res) => commit('SET_STEPS', res.data.data))
    },
    VALIDATE_STEP_1({
      state, commit, dispatch,
    }) {
      state.attemptingNavigation = true
      commit('TRIGGER_STEP_NAVIGATION', { step: 1 })
      dispatch('ui/SET_PAGELOAD_TRUE', undefined, { root: true })
    },
  },
  getters: {
    formIsComplete(state, getters, rootState) {
      const { booking } = rootState

      return !!(
        rootState.vehicles.set.storeVehicle
                && rootState.vehicles.set.storeVehicle.id
                && booking.pickUp.business
                && booking.pickUp.business.id
                && (!booking.oneWay || booking.drop.business)
                && (!booking.oneWay || booking.drop.business.id)
                && booking.pickUp.date
                && booking.drop.date
                && booking.pickUp.time
                && booking.drop.time
      )
    },

    isQuotationPage(state) {
      // step 2 for unlogged and 4 for logged
      return state.currentStep === 2 || state.currentStep === 4
    },
  },
}
